// extracted by mini-css-extract-plugin
module.exports = {"VideoFrame":"VideoFrame_VideoFrame__IyeA9","canvas":"VideoFrame_canvas__6rDnF"};